import React from "react";

import type { RowData } from "@tanstack/react-table-v9";

import type { AnyColumn } from "./layout";
import type { VirtualWindow } from "../../hooks/useGridVirtualizer";

const Spacer = ({ width }: { width: number }) => (
  <div data-spacer style={{ flex: `0 0 ${width}px` }} />
);

/** Pinned items always, unpinned ones only inside the column window, with spacers for the rest */
export const inColumnWindow = <TData extends RowData, T>(
  items: T[],
  columnOf: (item: T) => AnyColumn<TData>,
  columns: VirtualWindow | null,
  render: (item: T) => React.ReactNode,
) => {
  if (!columns) return items.map(render);
  const start: T[] = [];
  const center: T[] = [];
  const end: T[] = [];
  items.forEach((item) => {
    const pinned = columnOf(item).getIsPinned();
    (pinned === "start" ? start : pinned === "end" ? end : center).push(item);
  });
  return [
    ...start.map(render),
    columns.before > 0 && <Spacer key="spacer-before" width={columns.before} />,
    ...columns.indexes
      .map((index) => center[index])
      .filter((item) => item !== undefined)
      .map(render),
    columns.after > 0 && <Spacer key="spacer-after" width={columns.after} />,
    ...end.map(render),
  ];
};
